import React, { Component } from 'react';
import Colors from 'Colors.js';
import { connect } from "react-redux";
import Track from 'track/Track.js';
const colors = new Colors();

window.factorFill = 0.9;

class StepBottomComponent extends Component {
    constructor(props) {
        super(props);
        
    }

    brighten(c, factor) {
        let r = Math.min(255, Math.floor(parseInt(c.slice(1, 3), 16) * factor));
        let g = Math.min(255, Math.floor(parseInt(c.slice(3, 5), 16) * factor));
        let b = Math.min(255, Math.floor(parseInt(c.slice(5), 16) * factor));

        r = r.toString(16);
        g = g.toString(16);
        b = b.toString(16);

        if (r.length === 1) {
            r = '0' + r;
        }

        if (g.length === 1) {
            g = '0' + g;
        }

        if (b.length === 1) {
            b = '0' + b;
        }

        let x = '#' + r + g + b;

        return x;
    }

    render() {
        let fillStyle = {};
        if (this.props.fill) {
            let factorFill = 0.5;
            let fillColor = colors.brighten(colors.getColorForTrack(this.props.track), window.factorFill);
            fillStyle = {
                backgroundColor: fillColor
            };
        }

        if (this.props.stepData && this.props.on && this.props.stepData.duration < 1) {
            fillStyle.width = 30 * this.props.stepData.duration;
        }

        let fillClassName = 'fill ';
        if (this.props.isCurrentStep) {
            fillClassName += ' current-step';
        }

        if (this.props.isCursor) {
            fillClassName += ' cursor';
        }

        if (this.props.on) {
            fillClassName += ' on';
        }

        return (
            <div
              onMouseDown={(e) => this.props.onMouseDown(e)}
              onMouseUp={(e) => this.props.onMouseUp(e)}
              style={fillStyle} className={fillClassName}>
            </div>
        );
    }
}

export default StepBottomComponent;

